import React, { Component, createRef } from 'react'
import './App.css'
import withAuthentication from '../withAuthentication.jsx'
import withGroups from '../withGroups.jsx'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import AppBar from './layout/AppBar.jsx'
import Nav from './layout/Nav.jsx'
import Modal from './layout/Modal.jsx'
import EnterPremium from './modules/EnterPremium.jsx'
import CreateGroup from './modules/CreateGroup.jsx'
import EditGroup from './modules/EditGroup.jsx'
import ExitGroup from './modules/ExitGroup.jsx'
import ShareGroup from './modules/ShareGroup.jsx'
import AdminGroupMembers from './modules/AdminGroupMembers.jsx'
import AdminGroupDetails from './modules/AdminGroupDetails.jsx'
import Jornada from './modules/Jornada.jsx'
import Home from './screens/Home.jsx'
import Settings from './screens/Settings.jsx'
import Account from './screens/Account.jsx'
import Rules from './screens/Rules.jsx'
import FAQ from './screens/FAQ.jsx'
import About from './screens/About.jsx'
import Contact from './screens/Contact.jsx'
import Group from './screens/Group.jsx'
import Invite from './screens/Invite.jsx'
import NotFound from './screens/404.jsx'

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modal: {
        show: false,
        title: '',
        child: null,
        size: null
      }
    }
    this.modalRef = createRef()
    this.handleModal = this.handleModal.bind(this)
  }
  handleModal (module, params) {
    switch (module) {
      case 'createGroup':
        this.setState({
          modal: {
            show: true,
            title: 'Crear grupo',
            child: <CreateGroup closeModal={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))} />
          }
        })
        break
      case 'enterGroup':
        this.setState({
          modal: {
            show: true,
            title: 'Acceder a premium',
            child: <EnterPremium />
          }
        })
        break
      case 'editGroup':
        this.setState({
          modal: {
            show: true,
            title: 'Editar grupo',
            child: <EditGroup closeModal={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))} {...params} />
          }
        })
        break
      case 'exitGroup':
        this.setState({
          modal: {
            show: true,
            title: 'Abandonar grupo',
            child: <ExitGroup closeModal={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))} {...params} />
          }
        })
        break
      case 'shareGroup':
        this.setState({
          modal: {
            show: true,
            title: 'Invitar al grupo',
            child: <ShareGroup {...params} />
          }
        })
        break
      case 'adminGroupMembers':
        this.setState({
          modal: {
            show: true,
            title: 'Administrar participantes',
            child: <AdminGroupMembers closeModal={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))} {...params} />
          }
        })
        break
      case 'adminGroupDetails':
        this.setState({
          modal: {
            show: true,
            title: 'Detalles del grupo',
            child: <AdminGroupDetails closeModal={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))} {...params} />
          }
        })
        break
      case 'jornadaView':
        this.setState({
          modal: {
            show: true,
            title: params.title,
            child: <Jornada {...params} />,
            size: 'large'
          }
        })
        break
      default :
        this.setState({
          modal: {
            show: true,
            title: 'Error 404',
            child: <h4>La sección que estás buscando no existe</h4>
          }
        })
    }
  }
  render () {
    return (
      <Router>
        <div className='app'>
          <AppBar handleModal={this.handleModal} />
          <div className='app__container'>
            <Routes>
              <Route path='/' element={<Home handleModal={this.handleModal} />} />
              <Route path='/g/:id' element={<Group handleModal={this.handleModal} />} />
              <Route path='/invite/:id' element={<Invite />} />
              <Route path='/settings' element={<Settings />} />
              <Route path='/account' element={<Account />} />
              <Route path='/rules' element={<Rules />} />
              <Route path='/faq' element={<FAQ />} />
              <Route path='/about' element={<About />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='*' element={<NotFound />} />
            </Routes>
            <Nav />
          </div>
          <CSSTransition
            in={this.state.modal.show}
            nodeRef={this.modalRef}
            classNames={'modal'}
            timeout={400}
            mountOnEnter
            unmountOnExit>
            <div ref={this.modalRef}>
              <Modal title={this.state.modal.title} size={this.state.modal.size} handleClose={() => this.setState((prevState) => ({ modal: { show: false, title: prevState.modal.title, child: prevState.modal.child, size: prevState.modal.size } }))}>
                {this.state.modal.child}
              </Modal>
            </div>
          </CSSTransition>
        </div>
      </Router>
    )
  }
}

const AppGroups = withGroups(App)

export default withAuthentication(AppGroups)
